"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PageLevelHeadingProps_1 = require("./PageLevelHeadingProps");
var PageLevelHeadingState_1 = require("./PageLevelHeadingState");
/** Platform UI Components */
/** Stylesheets */
var icons = require("../../../styles/att-icon-login.scss");
var utilityStyles = require("../../../styles/utilities.scss");
var styles = require("./PageLevelHeading.scss");
/** LOB Components */
var PageLevelHeading = /** @class */ (function (_super) {
    __extends(PageLevelHeading, _super);
    function PageLevelHeading(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new PageLevelHeadingState_1.default();
        return _this;
    }
    PageLevelHeading.prototype.render = function () {
        var headingType;
        if (!this.props.options) {
            headingType = '';
        }
        else if (this.props.options.type === PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_WITH_ICON) {
            headingType = styles.pageLevelHeadingWithIcon;
        }
        else if (this.props.options.type === PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_MODAL) {
            headingType = styles.pageLevelHeadingModal;
        }
        return (React.createElement("div", { className: [styles.loginPageLevelHeadingWrapper].join(' '), "data-test-id": this.props.testId },
            React.createElement("div", { className: [utilityStyles.flex].join(' ') },
                (this.props.options && this.props.options.type === PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_WITH_ICON) &&
                    React.createElement("i", { className: [icons.attIconLogin, icons.attIconLoginAccountAccess].join(' '), role: "img", "aria-label": this.props.testId + '_Icon' }),
                React.createElement("div", { className: [headingType].join(' ') },
                    React.createElement("h1", null, this.props.data.headingText)))));
    };
    return PageLevelHeading;
}(React.Component));
exports.default = PageLevelHeading;
//# sourceMappingURL=PageLevelHeading.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelHeading/PageLevelHeading.js
// module id = 1519
// module chunks = 8